export enum typePlanning {
    ASST = "ASST",
    IST = "IST",
    PSY = "PSY",
    CONS = "CONS"
  }

export const typePlanningNumnberToEnum = {
  0: typePlanning.ASST,
  1: typePlanning.IST,
  2: typePlanning.PSY,
  3: typePlanning.CONS
};